import React from "react"
import { useTranslation } from "react-i18next"

import classNames from "classnames"

import { WithClassName } from "shared/types/WithClassName"
import { NumberInput } from "shared/ui/input/number/NumberInput"

import { useRoomFormContext } from "../../contexts/RoomFormContext"

export interface RoomAreaInputProps extends WithClassName {
  hideLabel?: boolean
}

export const RoomAreaInput = React.memo(
  ({ className, hideLabel }: RoomAreaInputProps) => {
    const { t } = useTranslation()
    const { isReadonly, isDisabled } = useRoomFormContext()

    return (
      <NumberInput.Root
        name="room.area"
        className={classNames("room-form__area", className)}
        label={t("Room.area")}
        unit="m²"
        readonly={isReadonly}
        disabled={isDisabled}
        format={{ maximumFractionDigits: 2 }}
        step={0.1}
        data-testid="room__area__input"
      >
        {!hideLabel && <NumberInput.Label showUnit />}
        <NumberInput.Group>
          <NumberInput.Decrement />
          <NumberInput.Focus>
            <NumberInput.Input />
          </NumberInput.Focus>
          <NumberInput.Increment />
        </NumberInput.Group>
        <NumberInput.Readonly showUnit />
        <NumberInput.ErrorMessage />
      </NumberInput.Root>
    )
  }
)
